import { render, staticRenderFns } from "./orderSalesReturn.vue?vue&type=template&id=0a27148e&scoped=true"
import script from "./orderSalesReturn.vue?vue&type=script&lang=js"
export * from "./orderSalesReturn.vue?vue&type=script&lang=js"
import style0 from "./orderSalesReturn.vue?vue&type=style&index=0&id=0a27148e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a27148e",
  null
  
)

export default component.exports